import React from 'react';
import Grid from '@material-ui/core/Grid';
import Table from './table';

export default function RiderDashboard() {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Table />
      </Grid>
    </Grid>
  );
}
